import PartItem from './PartItem'

export default PartItem;